'use strict';

var $ = require('jquery');

module.exports = function (options) {
  var context = options.context;

  var videoBlocks = context.find('.video-block');
  var videoList = context.find('[data-binding="video-list-item"]');

  function init() {
    if (videoList.length > 1) {
      videoList.first().addClass('playing');

      videoBlocks.find('.video-block__transcript').after('<button class="video-container__more-videos-button" data-binding="view-more-videos">More Videos</button>');

      context.find('[data-binding="view-more-videos"]').on('click', function (e) {
        var morevideos = context.find('[data-binding="more-videos"]');
        var wHeight = $(window).height(); // Height of view port
        var eOffset = morevideos.offset().top; // Y-offset of element
        var eHeight = morevideos.height(); // Height of element

        e.preventDefault();

        $('body').animate({ scrollTop: eOffset - wHeight + eHeight }, 300);
      });

      videoList.each(function (index) {
        var selectedVideo = $(this);
        var currentVideoIndex = index;
        selectedVideo.on('click', function () {
          videoList.removeClass('playing');
          selectedVideo.addClass('playing');

          videoBlocks.each(function (index) {
            if (!($(this).css('display') === 'hidden')) {
              $(this).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
              $(this).find('iframe:visible').css('left', '100%');
              $(this).find('.play-button').show();
              $(this).hide();
            }

            if (currentVideoIndex === index) {
              $(this).show();
              $(this).find('.play-button').click();
            }
          });
        });
      });
    }
  }

  return {
    init: init
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/video-container.js
// module id = 502
// module chunks = 0